import owaEmptyState_lib_svg_colored_searchingSvg from 'owa-empty-state/lib/svg/colored/searching.svg';
import owaEmptyState_lib_svg_gray_searchingSvg from 'owa-empty-state/lib/svg/gray/searching.svg';
import { Searching } from '../strings.locstring.json';
import loc from 'owa-localize';

import getStore from '../store';
import { CalendarSearchListViewState } from '../schema/CalendarSearchListViewState';
import { getIsLightBaseTheme } from 'owa-theme';
import { getOwaResourceUrl } from 'owa-resource-url';
import { initSearchResults } from '../actions/searchResultStoreActions';
import { mutator } from 'satcheljs';

/**
 * Reset/Initialize search results store
 */
export let initSearchResultsMutator = mutator(initSearchResults, () => {
    let store = getStore();
    const SEARCHING_SVG = getIsLightBaseTheme()
        ? owaEmptyState_lib_svg_colored_searchingSvg
        : owaEmptyState_lib_svg_gray_searchingSvg;
    store.searchResults = [];
    store.autoScrollItemId = undefined;
    store.selectedItemId = undefined;
    store.isPastDayFound = false;
    store.searchMode = CalendarSearchListViewState.Loading;
    store.emptyListContents = {
        icon: getOwaResourceUrl(SEARCHING_SVG),
        mainMessage: loc(Searching),
    };
    store.currentInstrumentationContext = null;
    store.fetchingFullItem = false;
    store.hideNotificationBar = false;
    store.editedResultsCount = 0;
    store.searchTerms = [];
});
